<section class="update-dialog" [class.dark-mode]="whatsappThemeService.isDarkMode()">
  <header class="update-header">
    <span class="header-icon" aria-hidden="true"><mat-icon>system_update_alt</mat-icon></span>
    <div class="header-copy">
      <h2 mat-dialog-title>{{ data.title }}</h2>
      <p>{{ data.summary || 'Hay una nueva versión del sistema.' }}</p>
    </div>
  </header>

  <mat-dialog-content class="update-content">
    <ul class="update-list" aria-label="Cambios incluidos en esta actualización">
      @for (feature of paginatedFeatures(); track feature.description) {
        <li>
          <mat-icon>{{ feature.icon || 'check_circle' }}</mat-icon>
          <span>{{ feature.description }}</span>
        </li>
      }
    </ul>

    <div class="reload-note" [class.reload-warning]="data.retryLimitReached">
      <mat-icon>{{ data.retryLimitReached ? 'warning' : 'refresh' }}</mat-icon>
      <span>
        @if (data.retryLimitReached) {
          La versión nueva no se pudo cargar automáticamente. Cerrá las demás pestañas de la aplicación y reintentá manualmente.
        } @else {
          Para recibir estos cambios, la aplicación debe recargarse ahora.
        }
      </span>
    </div>
  </mat-dialog-content>

  @if (showPaginator()) {
    <div class="update-pagination">
      <mat-paginator
        [length]="data.features.length"
        [pageIndex]="currentPageIndex()"
        [pageSize]="pageSize"
        [hidePageSize]="true"
        [showFirstLastButtons]="false"
        (page)="onPageChange($event)"
        aria-label="Paginación de novedades">
      </mat-paginator>
    </div>
  }

  <mat-dialog-actions align="end" class="update-actions">
    <button mat-flat-button type="button" class="btn-update" (click)="actualizar()">
      <mat-icon>refresh</mat-icon>
      {{ data.retryLimitReached ? 'Reintentar manualmente' : 'Actualizar ahora' }}
    </button>
  </mat-dialog-actions>
</section>
